export default {
  alerts: {
    role: 'feature:qc-alerts',
    displayName: 'Alerts: Quality Control Alerts',
    description: 'Grants access to QC Alerts'
  }
}
